import MapViewportState from "@app/types/map/MapViewportState";

export const DEFAULT_VIEW_PORT: MapViewportState = {
  bounds: {
    bottom_right: [180, -90],
    top_left: [-180, 90],
  },
  zoom: 1,
};
